// extracted by mini-css-extract-plugin
export default {"btnlist":"Button_btnlist__UrfJs","btn":"Button_btn__96KhQ"};